import React from 'react';
import { Badge, Tooltip } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { request } from '@umijs/max';

interface Props {
  user?: API.CurrentUser;
  refreshKey: string;
  className?: string;
  onOpen: () => void;
}

/** 仅物流补明细岗位读取自己的待办数量；无需跨部门访问业务明细。 */
const CustomerEntryReminder: React.FC<Props> = ({ user, refreshKey, className, onOpen }) => {
  const permissions = user?.permissions || [];
  const allowed = user?.access === 'admin' || permissions.includes('*') || permissions.includes('warehouse.customer_entry_notice.declare');
  const [total, setTotal] = React.useState(0);
  const userId = (user as any)?.id ?? user?.userid;
  const organizationId = (user as any)?.organizationId;
  React.useEffect(() => {
    setTotal(0);
    if (!allowed || !user) return undefined;
    let stopped = false;
    let busy = false;
    const controller = new AbortController();
    const refresh = async () => {
      if (busy || document.visibilityState === 'hidden') return;
      busy = true;
      try {
        const result = await request<any>('/api/warehouse/customer-entry-notice/pending-declarations', {
          params: { current: 1, pageSize: 1 }, signal: controller.signal, skipErrorHandler: true, pageLoading: false,
        });
        if (!stopped) setTotal(Math.max(0, Number(result?.total ?? result?.data?.total ?? 0)));
      } catch { if (!stopped) setTotal(0); }
      finally { busy = false; }
    };
    void refresh();
    const timer = window.setInterval(() => void refresh(), 60_000);
    const visible = () => { if (document.visibilityState === 'visible') void refresh(); };
    document.addEventListener('visibilitychange', visible);
    return () => { stopped = true; controller.abort(); window.clearInterval(timer); document.removeEventListener('visibilitychange', visible); };
  }, [allowed, userId, organizationId, refreshKey]);
  return <Tooltip title={allowed ? `客户进仓待补明细：${total} 单` : '系统通知'}>
    <button type="button" className={className} disabled={!allowed}
      style={{ appearance: 'none', border: 0, padding: 0, background: 'transparent', color: 'inherit', font: 'inherit' }}
      aria-label={allowed ? `客户进仓待补明细 ${total} 单` : '系统通知'}
      onClick={allowed ? onOpen : undefined}>
      <Badge count={total} size="small" offset={[-2, 2]}><BellOutlined /></Badge>
    </button>
  </Tooltip>;
};
export default CustomerEntryReminder;
